"use strict";

exports.__esModule = true;
exports.IconsBar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _VimanaIcon = require("../../VimanaIcon");
var _StripeChartTooltipDate = require("./StripeChartTooltipDate");
var _User = require("../../User");
var _utils = require("./utils");
var _styles = require("./styles");
var _helpers = require("../../InstantaneousEvent/helpers");
var _MARKER_COLORS;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var DATE_FORMAT = "MMM D, hh:mm A";

// Lane markers from the next-gen design: a small rounded square per event,
// coloured by type. The tooltip still carries the event's icon.
var MARKER_SIZE = 9;
var MARKER_COLORS = (_MARKER_COLORS = {}, _MARKER_COLORS[_helpers.InstantaneousEventAlerts] = "#D8453B", _MARKER_COLORS[_helpers.InstantaneousEventTickets] = "#E8621E", _MARKER_COLORS[_helpers.InstantaneousEventComments] = "#9FB4C4", _MARKER_COLORS);
var Marker = _styledComponents["default"].div.withConfig({
  displayName: "IconsBarmodern__Marker",
  componentId: "sc-18758wz-0"
})(["width:", "px;height:", "px;border-radius:2px 2px 2px 0;background:", ";box-shadow:0 0 0 1.5px #ffffff;cursor:pointer;"], MARKER_SIZE, MARKER_SIZE, function (props) {
  return props.$color;
});
var showId = function showId(eventType) {
  return eventType === _helpers.InstantaneousEventTickets;
};
function getIconTooltipContent(args) {
  var icon = args.icon,
    description = args.description,
    height = args.height,
    id = args.id,
    created = args.created,
    theme = args.theme,
    username = args.username,
    eventType = args.eventType;
  return /*#__PURE__*/_react["default"].createElement(_styles.IconTooltipContent, {
    "data-testid": "IconTooltipContent"
  }, /*#__PURE__*/_react["default"].createElement(_styles.EventIconContainer, null, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
    icon: icon,
    iconSize: height * 1.25,
    alt: icon,
    margin: "3px 0 0 0"
  })), /*#__PURE__*/_react["default"].createElement(_styles.IconTooltipContentHeader, null, username ? /*#__PURE__*/_react["default"].createElement(_styles.IconTooltipUsername, {
    "data-testid": "IconTooltipUsername"
  }, username) : null, id && showId(eventType) ? /*#__PURE__*/_react["default"].createElement(_styles.IconTooltipId, {
    "data-testid": "IconTooltipId"
  }, "#", id) : null), /*#__PURE__*/_react["default"].createElement(_styles.IconTooltipContentDescription, {
    "data-testid": "IconTooltipContentDescription"
  }, description), /*#__PURE__*/_react["default"].createElement(_StripeChartTooltipDate.StripeChartTooltipDate, {
    timeInMs: created,
    format: DATE_FORMAT,
    style: {
      fontSize: theme.fontSizeXXXS,
      gridArea: "date",
      padding: "4px 4px 0 8px",
      color: theme.TooltipContentColor
    }
  }));
}
var IconsBar = exports.IconsBar = (0, _styledComponents.withTheme)(function (props) {
  var height = props.height,
    width = props.width,
    instantaneousEventList = props.instantaneousEventList,
    scale = props.scale,
    theme = props.theme;
  var users = _react["default"].useContext(_User.UserListContext);
  var _useState = (0, _react.useState)(""),
    activeEventId = _useState[0],
    setActiveEventId = _useState[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: width,
      height: height
    },
    "data-testid": "IconsBar"
  }, instantaneousEventList.map(function (_ref) {
    var icon = _ref.icon,
      created = _ref.created,
      description = _ref.description,
      id = _ref.id,
      creatorId = _ref.creatorId,
      eventType = _ref.eventType;
    var username = (0, _utils.getFormattedUserName)(creatorId, users, eventType);
    var leftDistance = scale(created);
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "IconEventDiv-" + icon + "-" + id,
      key: icon + "-" + id,
      onMouseEnter: function onMouseEnter() {
        setActiveEventId(icon + "-" + id);
      },
      onMouseLeave: function onMouseLeave() {
        setActiveEventId("");
      },
      style: {
        position: "absolute",
        left: leftDistance + "px"
      }
    }, activeEventId === icon + "-" + id ? /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
      popoverClassName: ["chart-tooltip"],
      isOpen: activeEventId === icon + "-" + id,
      position: leftDistance > width / 2 ? _core.Position.BOTTOM_RIGHT : _core.Position.BOTTOM_LEFT,
      content: getIconTooltipContent({
        icon: icon,
        description: description,
        height: height,
        id: id,
        created: created,
        theme: theme,
        username: username,
        eventType: eventType
      })
    }, /*#__PURE__*/_react["default"].createElement("div", null)) : null, /*#__PURE__*/_react["default"].createElement(Marker, {
      "data-testid": "IconEventMarker-" + icon + "-" + id,
      title: description,
      $color: MARKER_COLORS[eventType] || "#9FB4C4",
      style: {
        marginLeft: -MARKER_SIZE / 2,
        marginTop: Math.max(0, (height - MARKER_SIZE) / 2)
      }
    }));
  }));
});